export default __webpack_public_path__ + "13d68ebf6968836c166aa345438c0dbc.png";